import { TimeSlotFeeDataForDetailConfirmationPage } from './TimeSlotFeeDataForDetailConfirmationPage';
export class TimeSlotFeeDataUConverter {
    static getDataForDetailConfirmationPage({ timeSlotFeeData, timeSlotCount, }) {
        const data = new TimeSlotFeeDataForDetailConfirmationPage({ timeSlotFeeData, timeSlotCount });
        return data;
    }
}
